export interface PhoneModel {
  label: string;
  value: string;
  model: string;
}

export enum PhoneCaseModel {
  Iphone11 = 'iphone_11',
  Iphone11Pro = 'iphone_11_pro',
  Iphone11ProMax = 'iphone_11_pro_max',
  Iphone12 = 'iphone_12',
  Iphone12Pro = 'iphone_12_pro',
  Iphone12ProMax = 'iphone_12_pro_max',
  Iphone12Mini = 'iphone_12_mini',
  Iphone13 = 'iphone_13',
  Iphone13Pro = 'iphone_13_pro',
  Iphone13ProMax = 'iphone_13_pro_max',
  Iphone13Mini = 'iphone_13_mini',
  Iphone14 = 'iphone_14',
  Iphone14Plus = 'iphone_14_plus',
  Iphone14Pro = 'iphone_14_pro',
  Iphone14ProMax = 'iphone_14_pro_max',
  Iphone15 = 'iphone_15',
  Iphone15Plus = 'iphone_15_plus',
  Iphone15Pro = 'iphone_15_pro',
  Iphone15ProMax = 'iphone_15_pro_max',
  Iphone16 = 'iphone_16',
  Iphone16Plus = 'iphone_16_plus',
  Iphone16Pro = 'iphone_16_pro',
  Iphone16ProMax = 'iphone_16_pro_max',
  IphoneX = 'iphone_X',
  IphoneXR = 'iphone_XR',
  IphoneXS = 'iphone_XS',
  IphoneXSMax = 'iphone_XS_Max',
}
